var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGooglePlayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2224 13.75L0.242188 26.0125C0.376724 26.4783 0.61849 26.9078 0.949005 27.2684C1.27952 27.6289 1.69003 27.9108 2.14916 28.0926C2.60829 28.2743 3.10389 28.3511 3.59806 28.3171C4.09222 28.2831 4.57189 28.1391 5.00038 27.8962L18.4804 20.3958L12.2224 13.75Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3399 11.6604L18.5107 8.39844L11.9492 14.0237L18.5374 20.373L24.3222 17.146C24.8347 16.8838 25.2639 16.4896 25.5634 16.0061C25.8629 15.5226 26.0213 14.9683 26.0213 14.4031C26.0213 13.838 25.8629 13.2836 25.5634 12.8001C25.2639 12.3166 24.8347 11.9225 24.3222 11.6603L24.3399 11.6604Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.243923 2.74219C0.17151 3.00373 0.135462 3.2736 0.136752 3.54454V25.2087C0.137503 25.4795 0.173516 25.7491 0.243923 26.0111L12.6348 14.0626L0.243923 2.74219Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3117 14.3763L18.5072 8.40204L5.04507 0.866667C4.53857 0.576867 3.96249 0.423394 3.37552 0.421881C1.91891 0.419115 0.638316 1.36361 0.242188 2.73313L12.3117 14.3763Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8828,
    height: 27.9534,
    fill: "white",
    transform: "translate(0.136719 0.421875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGooglePlayIcon);
export default __webpack_public_path__ + "static/media/logos_google-play-icon.a1e2427f42fbeb15c67aa63afc38799b.svg";
export { ForwardRef as ReactComponent };